












































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import {
  GetTicketAttrsOptionReq,
  GetTicketAssignRulesReq,
  SaveTicketAssignRuleReq,
  DeleteTicketAssignRuleReq,
  TicketAssignRuleAttr,
  AttrItem,
} from "@/pbjs/external/ticket/ticket_pb";
import { ticketClient, authorClient } from "@/api/index";
import { timeFormat, addZero, arrRemove } from "@/utils/index";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage } from "@/utils/request";
import { downloadFile } from "@/utils/index";

@Component({
  name: "CombinationProperty",
})
export default class CombinationProperty extends Vue {
  @Provide() private filterText: string = "";
  @Provide() private systemtype: number = 2;
  @Provide() private resultData: any = [];
  @Provide() private token: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private sortticketList: any = [];
  @Provide() private sortadminList: any = [];
  @Provide() private assignmodeList: any = [];
  @Provide() private combOptions: any = [];
  @Provide() private loadAttrList: any = [];
  @Provide() private roleGroupList: any = [];
  @Provide() private roleGroupNewList: any = [];
  @Provide() private txt: any = this.$t;
  @Provide() private IsFinalList: any = [
    {
      value: 1,
      name: "v0707.Yes",
    },
    {
      value: 0,
      name: "v0707.No",
    },
  ];
  @Provide() private WorkDayList: any = [
    {
      value: "1",
      key: "WorkDayList1",
      name: "Mon to Fri",
    },
    {
      value: "2",
      key: "WorkDayList2",
      name: "Weekend",
    },
  ];
  @Provide() private timeOptions: string[] = ["时间点", "时间段"];
  @Provide() private actionOptions: any = [];
  @Provide() private WorkModeOptions: any = [];
  @Provide() private showTimeType: string = "";
  @Provide() private userId: any;
  @Provide() private isEditId: number = 0;
  @Provide() private isEditName: boolean = false;
  @Provide() private attr: any;
  @Provide() private form: any = {
    moment: "",
    period: [new Date(2020, 6, 1, 0, 0), new Date(2020, 6, 1, 23, 59)],
    actionValue: "",
    assignModeValue: "",
    sortAdminValue: "",
    sortTicketValue: [],
    combValue: [],
    loadAttrValue: [],
    name: "",
    IsFinal: "",
    WorkDay: "",
    roleGroupValue: [],
    roleGroupNewValue: [],
    pvworkermaxworkload: "",
    pvdailymaxworkload: ""
  };
  @Provide() private isGetTicketAssignRulesActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;

  private created() {
    this.token = localStorage.getItem("token");
    this.userId = localStorage.getItem("userid");
    this.getTicketAssignParam();
    this.getTicketAttrsOption();
    this.getTicketAssignRulesAction();
    this.listRole();
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketAssignRules();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketAssignRules();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketAssignRules();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketAssignRules();
  }

  private getTicketAssignRulesAction() {
    this.isGetTicketAssignRulesActionDone = true;
    this.pageIndex = 1;
    this.getTicketAssignRules();
  }
  private editName() {
    this.isEditName = true;
  }

  // 编辑
  private editDistributeItem(row: any) {
    this.resetForm();
    this.isEditId = row.id;
    this.form.name = row.attrs.name;
    if (this.form.name) {
      this.isEditName = true;
    }
    this.form.assignModeValue = row.attrs.assignmodeList && row.attrs.assignmodeList[0];
    this.form.sortAdminValue = row.attrs.sortadminList && row.attrs.sortadminList[0];
    this.form.sortTicketValue = row.attrs.sortticketList;
    this.form.combValue = row.attrs.ticketattrList;
    this.form.loadAttrValue = row.attrs.loadattrList;
    this.form.roleGroupValue = row.attrs.adminattrList;
    this.form.roleGroupNewValue = row.attrs.userattrList;
    this.form.IsFinal = row.attrs.isfinal;
    this.form.WorkDay = row.attrs.workday;
    this.form.systemtype = row.attrs.systemtype;
    this.form.pvworkermaxworkload = row.attrs.pvworkermaxworkload;
    this.form.pvdailymaxworkload = row.attrs.pvdailymaxworkload;
    
    if (row.attrs.assigntime) {
      this.showTimeType = "时间点";
      let time = row.attrs.assigntime.split(":");
      this.form.moment = new Date(2020, 6, 1, Number(time[0]), Number(time[1]));
    }
    if (row.attrs.begintime) {
      this.showTimeType = "时间段";
      let start = row.attrs.begintime.split(":");
      let end = row.attrs.endtime.split(":");
      this.form.period = [
        new Date(2020, 6, 1, Number(start[0]), Number(start[1])),
        new Date(2020, 6, 1, Number(end[0]), Number(end[1])),
      ];
      if (row.attrs.timeaction) {
        this.form.actionValue = row.attrs.timeaction + "";
      }
    }
  }
  // 接单人群
  private listRole() {
    let request: any = setCommon();
    authorClient.listRole(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (data.commonout) {
          if (data.commonout.code == 0) {
            this.roleGroupList = data.roletreeList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        } else {
          if (data.code == 0) {
            this.roleGroupList = data.roletreeList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private resetForm() {
    const ref: any = this.$refs["form"];
    ref.resetFields();
    this.form.moment = "";
    this.form.period = [new Date(2020, 6, 1, 0, 0), new Date(2020, 6, 1, 23, 59)];
    this.showTimeType = "";
    this.form.name = "";
    this.form.WorkDay = "";
  }
  // 获取工单分配支持的所有的参数数据
  private async getTicketAssignParam() {
    let _arg: any = {
      systemType: 2,
    };
    const { getTicketAssignParam }: any = await import("@/request/getTicketAssign");
    let res = await getTicketAssignParam(_arg);
    if (res && res.param) {
      this.sortticketList = res.param.sortticketList;
      this.sortadminList = res.param.sortadminList;
      this.assignmodeList = res.param.assignmodeList;
      this.actionOptions = res.param.timeactionList;
      this.WorkModeOptions = res.param.workmodeList;
    }
  }
  // table数据
  private getTicketAssignRules() {
    let request: any = new GetTicketAssignRulesReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    request.setName(this.filterText);
    request.setSystemtype(this.systemtype);
    ticketClient.getTicketAssignRules(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.pagerCount = data.pageout.total;
          data.listList.forEach((item: any) => {
            item.utime = timeFormat(item.utime);
          });
          this.resultData = data.listList;
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
      this.isGetTicketAssignRulesActionDone = false;
    });
  }
  // 获取工单组合属性下拉选项
  private getTicketAttrsOption() {
    let request: any = new GetTicketAttrsOptionReq();
    request.setCommonin(setCommon());
    request.setSystemtype(this.systemtype);
    ticketClient.getTicketAttrsOption(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.combOptions = data.listList;
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  // 停用、启用
  private stopOrStartAssignRuleAction(id: number, action: number) {
    this.dwAssignRule({
      id: Number(id),
      action: Number(action),
    });
  }
  // 删除
  private deleteAssignRuleAction(id: number) {
    this.dwAssignRule({
      id: Number(id),
      action: 3,
    });
  }
  // 启用停用和删除工用的处理参数、请求的函数
  private async dwAssignRule(options: any) {
    interface IDeleteTicketRecycleRuleReqOptions {
      id: number;
      action: number;
    }
    let _arg: IDeleteTicketRecycleRuleReqOptions = {
      id: Number(options.id),
      action: Number(options.action),
    };
    const { deleteTicketAssignRule }: any = await import(
      "@/request/deleteTicketAssignRule"
    );
    let response = await deleteTicketAssignRule(_arg, this);
    if (response && response.commonout) {
      if (response.commonout.code == 0) {
        this.$message({
          message: "success",
          type: "success",
        });
        if (options.action == 3) {
          let _item = this.resultData.find((item: any) => {
            if (item.id == options.id) {
              return item;
            }
          });
          arrRemove(this.resultData, _item);
        } else {
          this.resultData = this.resultData.map((item: any) => {
            item.attrs.workstatus =
              item.id == options.id
                ? item.attrs.workstatus == 1
                  ? 0
                  : 1
                : item.attrs.workstatus;
            return item;
          });
        }
      } else {
        this.$message({
          message: response.commonout.errmsg,
          type: "error",
        });
      }
    }
  }
  //   保存
  private saveTicketAssignRule() {
    let moment =
      this.form.moment &&
      this.form.moment.getHours() + ":" + this.form.moment.getMinutes();
    let request: any = new SaveTicketAssignRuleReq();
    let saveItem: any = new TicketAssignRuleAttr();
    if (this.showTimeType == "时间点") {
      saveItem.setAssigntime(this.formatTime(this.form.moment));
    }
    if (this.showTimeType == "时间段") {
      saveItem.setBegintime(this.form.period && this.formatTime(this.form.period[0]));
      saveItem.setEndtime(this.form.period && this.formatTime(this.form.period[1]));
      saveItem.setTimeaction(Number(this.form.actionValue));
    }
    saveItem.setTicketattrList(this.form.combValue);
    saveItem.setSortticketList(this.form.sortTicketValue);
    saveItem.setSortadminList([this.form.sortAdminValue]);
    saveItem.setAssignmodeList([this.form.assignModeValue]);
    saveItem.setAdminattrList(this.form.roleGroupValue);
    saveItem.setLoadattrList(this.form.loadAttrValue);
    saveItem.setUserattrList(this.form.roleGroupNewValue);
    saveItem.setName(this.form.name);
    saveItem.setIsfinal(Number(this.form.IsFinal));
    saveItem.setWorkday(this.form.WorkDay);
    saveItem.setSystemtype(this.systemtype);
    saveItem.setPvworkermaxworkload(+this.form.pvworkermaxworkload);
    saveItem.setPvdailymaxworkload(+this.form.pvdailymaxworkload);
    
    request.setCommonin(setCommon());
    request.setId(this.isEditId);
    request.setData(saveItem);
    ticketClient.saveTicketAssignRule(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.isEditName = false;
          this.isEditId = 0;
          this.resetForm();
          this.getTicketAssignRules();
          this.$message({
            message: "submit successfully",
            type: "success",
          });
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private formatTime(time: Date | null): any {
    if (time) {
      return addZero(time.getHours()) + ":" + addZero(time.getMinutes());
    } else {
      return time;
    }
  }
}
